import { CandlestickSeries as CandlestickSeriesDefinition } from "lightweight-charts";
import merge from "lodash/merge";
import { CandlestickSeriesOptions, ChartCandle } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { candleSeriesOptions } from "../../../assets/constants";

class HeikinAshiSeries extends BaseChartSeries<ChartCandle, CandlestickSeriesOptions> {

    addSeriesToChart() {
        return this.createSeries(CandlestickSeriesDefinition, this.seriesOptions)
    }

    getDefaultOptions(): CandlestickSeriesOptions {
        return merge(candleSeriesOptions, this.options)
    }

    generateSeriesData(data: ChartCandle[], metadata?: Record<string, any>): ChartCandle[] {
        const heikinAshiCandles: ChartCandle[] = []

        for (let i = 1; i < data.length; i++) {
            const candle = data[i];
            const prevCandle = (i > 1) ? heikinAshiCandles[heikinAshiCandles.length - 1] : data[i - 1]
            const candleHigh = candle.high
            const candleLow = candle.low
            const candleOpen = candle.open
            const candleClose = candle.close
            const prevCandleOpen = prevCandle.open
            const prevCandleClose = prevCandle.close

            const heikinClose = (candleOpen + candleClose + candleHigh + candleLow) / 4
            const heikinOPen = (prevCandleOpen + prevCandleClose) / 2
            const heikinHigh = Math.max(candleHigh, Math.max(heikinClose, heikinOPen))
            const heikinLow = Math.min(candleLow, Math.min(heikinClose, heikinOPen))
            heikinAshiCandles.push({
                ...candle,
                time: candle.time,
                close: heikinClose,
                open: heikinOPen,
                high: heikinHigh,
                low: heikinLow
            })
        }

        return heikinAshiCandles;
    }
}

export default HeikinAshiSeries;

